import * as React from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { useDispatch } from 'react-redux'
import { signupUser } from './index.reducer'

const SignupForm: React.FC<InjectedFormProps> = props => {
  const { handleSubmit } = props
  const dispatch = useDispatch()

  const submitLogin = (submittedValues: any) => {
    dispatch(signupUser(submittedValues))
  }
  return (
    <form onSubmit={handleSubmit(submitLogin)}>
      <Field
        name="userName"
        component="input"
        type="text"
        placeholder="Enter User Name"
      />
      <br />
      <Field
        name="email"
        component="input"
        type="text"
        placeholder="Enter Email"
      />
      <br />
      <Field
        name="firstName"
        component="input"
        type="text"
        placeholder="Enter First Name"
      />
      <br />
      <Field
        name="lastName"
        component="input"
        type="text"
        placeholder="Enter Last Name"
      />
      <br />
      <Field
        name="age"
        component="input"
        type="number"
        placeholder="Enter Number"
      />
      <br />
      <button 
      type='submit'>Submit</button>
    </form>
  )
}

export default reduxForm({ form: 'SignupForm' })(SignupForm)
